import filter from 'lodash/filter';

export class HomeBannerService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.bannerListResourceUrl = this.apiService.getResourceUrl('cms/menus/home-banner');
		this.bannerAddResourceUrl = this.apiService.getResourceUrl('cms/banner');
		this.bannerEditDeleteGetByIdResourceUrl = this.apiService.getResourceUrl('cms/banner/:content_id');
		this.bannerPublishUnpublishResourceUrl = this.apiService.getResourceUrl('cms/banner/publish/:content_id');
		this.bannerEditSequenceListResourceUrl = this.apiService.getResourceUrl('cms/banner/sequence');

		this.bannerListResource = this.$resource(this.bannerListResourceUrl);
		this.bannerAddResource = this.$resource(this.bannerAddResourceUrl, null, {
			save: {
				method: 'POST'
			}
		});
		this.bannerEditDeleteGetByIdResource = this.$resource(this.bannerEditDeleteGetByIdResourceUrl, null, {
			get: {
				method: 'GET',
				params: {
					content_id: '@content_id'
				}
			},
			update: {
				method: 'PUT',
				params: {
					content_id: '@content_id'
				}
			},
			delete: {
				method: 'DELETE',
				params: {
					content_id: '@content_id'
				}
			}
		});
		this.bannerPublishUnpublishResource = this.$resource(this.bannerPublishUnpublishResourceUrl, null, {
			update: {
				method: 'PUT',
				params: {
					content_id: '@content_id'
				}
			}
		});
		this.bannerEditSequenceListResource = this.$resource(this.bannerEditSequenceListResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		})
	}

	_getContentDetails(content) {
		return content.reduce((list, value) => {
			if (value.name === 'HomeBanner') {
				let publishedList = filter(value.values, 'is_active');
				let unPublishedList = filter(value.values, ['is_active', false]);

				list.publishedList = list.concat(_getListDetails(publishedList));
				list.unPublishedList = list.concat(_getListDetails(unPublishedList));
			}
			return list;
		}, []);

		function _getListDetails(data) {
			return data.map(value => ({
				id: value.content_id,
				sortOrder: value.sort_order,
				isActive: value.is_active,
				title: value.details.title,
				image: value.details.image,
				url: value.details.url,
				description: value.details.description,
				buttonText: value.details.button_text,
				slug: value.slug || ""
			}));
		}
	}

	_getBannerObject(value) {
		return {
			url: value.url,
			title: value.title,
			description: value.description,
			buttonText: value.button_text,
			image: value.image,
			ada: value.ada || {}
		}
	}

	_setBannerObject(value) {
		return {
			url: value.url,
			title: value.title,
			description: value.description,
			button_text: value.buttonText,
			image: value.image,
			ada: value.ada || {}
		}
	}

	//get content sequence object for display
	_getContentSequence(value) {
		return value.map((content) => {
			return {
				id: content.content_id,
				sortOrder: content.sort_order,
				title: content.title
			}
		});
	}

	//set content sequence object for update
	_setContentSequence(value) {
		return value.map((content) => {
			return {
				content_id: content.id,
				sort_order: content.sortOrder,
				title: content.title
			}
		});
	}

	/**
	 * function to get banner list
	 * @return {object} [information related to banner list]
	 */
	// getBannerList() {
	// 	const promise = this.bannerListResource.get().$promise;

	// 	return promise.then(details => this._getContentDetails(details.data.content))
	// 	.catch((error) => {
	// 		throw this.apiService.getErrorMessage(error);
	// 	});
	// }

	getBannerList(details) {
		return this._getContentDetails(details.data.content);
	}

	// getBannerDetailsById(id) {
	// 	const promise = this.bannerEditDeleteGetByIdResource.get({
	// 		content_id: id
	// 	}).$promise;

	// 	return promise.then(details => this._getBannerObject(details.data))
	// 		.catch((error) => {
	// 			throw this.apiService.getErrorMessage(error);
	// 		});
	// }

	getBannerDetailsById(details) {
		return this._getBannerObject(details.data);
	}

	/**
	 * function to add banner
	 * @return {object} [information related to banner for add]
	 */
	// addBanner(details) {
	// 	const promise = this.bannerAddResource.save(this._setBannerObject(details)).$promise;

	// 	return promise.then(details => details.data)
	// 		.catch((error) => {
	// 			throw this.apiService.getErrorMessage(error);
	// 		});
	// }

	/**
	 * function to edit banner
	 * @return {object} [information related to banner for edit]
	 */
	// updateBanner(details, id) {
	// 	const promise = this.bannerEditDeleteGetByIdResource.update({
	// 		content_id: id
	// 	}, this._setBannerObject(details)).$promise;

	// 	return promise.then(details => details.data)
	// 		.catch((error) => {
	// 			throw this.apiService.getErrorMessage(error);
	// 		});
	// }

	/**
	 * function to delete banner
	 * @return {object} [information related to banner for delete]
	 */
	// deleteBanner(id) {
	// 	const promise = this.bannerEditDeleteGetByIdResource.delete({ content_id: id }).$promise;

	// 	return promise.then(details => details.data)
	// 		.catch((err) => {
	// 			throw this.apiService.getErrorMessage(err);
	// 		});
	// }

	/**
	 * function to publish/unpublish banner
	 * @return {object} [information related to banner for publish/unpublish]
	 */
	publishUnpublishBanner(id, isActive) {
		const promise = this.bannerPublishUnpublishResource.update({
			content_id: id
		}, { is_active: isActive }).$promise;

		return promise.then(details => this._getContentDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	//get content sequence service
	// getHomeBannerEditSequence() {
	// 	const promise = this.bannerEditSequenceListResource.get().$promise;

	// 	return promise.then((details) => {
	// 		return this._getContentSequence(details.data);
	// 	});
	// }

	getHomeBannerEditSequence({ data: { content: { values } } }) {
		return this._getContentSequence(values);
	}

	//update content sequence service
	setHomeBannerEditSequence(sequenceObj) {
		const obj = {};
		obj.sequence = this._setContentSequence(sequenceObj);

		const promise = this.bannerEditSequenceListResource.update(obj).$promise;

		return promise.then((response) => {
			return response;
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/components/home-banner/home-banner.service.js